import React from 'react';
import { Button, Typography } from '@mui/material';
import AppDialog, { AppDialogTitle, AppDialogContent, AppDialogActions } from '../layout/AppDialog';

const ConfirmDialog = ({ open, title, content, onConfirm, onCancel, confirmLabel = 'Confirm', confirmColor = 'error' }) => {
  return (
    <AppDialog open={open} onClose={onCancel} maxWidth="xs">
      <AppDialogTitle onClose={onCancel} subtitle="This action cannot be undone">
        {title}
      </AppDialogTitle>
      <AppDialogContent dividers={false}>
        <Typography sx={{ color: 'text.secondary', lineHeight: 1.6 }}>{content}</Typography>
      </AppDialogContent>
      <AppDialogActions>
        <Button onClick={onCancel} variant="outlined" color="inherit">
          Cancel
        </Button>
        <Button onClick={onConfirm} color={confirmColor} variant="contained">
          {confirmLabel}
        </Button>
      </AppDialogActions>
    </AppDialog>
  );
};

export default ConfirmDialog;
